import { ref } from 'config/constants'
import { showMessage } from 'data/messages/actions';
import {
    FETCH_BILLS,
    FETCH_BILLS_SUCCESS,
    UPDATE_BILL,
    
} from './types';
import { OrderStatus } from 'data/orders/types';

const Bill = ref.child("bills");

/* Pampaign */
export function fetchBills(accountid) {
    return dispatch => {
        dispatch({
            type: FETCH_BILLS,
            payload: { pending: true }
        });
        Bill.child(accountid).on('value', snapshot => {
            dispatch({
                type: FETCH_BILLS_SUCCESS,
                payload: snapshot.val()
            });
        });
    };
}


export function addBill(accountid, bill, callback) {
    bill.accountid = accountid;
    bill.created = new Date().getTime();
    return dispatch => Bill.child(accountid).push(bill).then( (snapshot) => { 
        callback(snapshot.key)
    })
}



// WEBPACK FOOTER //
// ./src/data/bills/actions.js